import { JSX } from "react";

import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import ModuleVersionTableEmptyCell from "views/Account/Module/Version/components/TableEmptyCell";
import ModuleVersionTableNameCell from "views/Account/Module/Version/components/TableNameCell";

import {
  MODULE_VERSION_OPTIONAL_INPUTS_COLUMN_ID,
  MODULE_VERSION_REQUIRED_INPUTS_COLUMN_ID,
} from "../constants";
import { ModuleVersionOptionalInputRow, ModuleVersionRequiredInputRow } from "../types";
import ModuleVersionInputsTableDefaultCell from "./DefaultCell";
import ModuleVersionInputsTableDescriptionCell from "./DescriptionCell";
import ModuleVersionInputsTableTypeCell from "./TypeCell";

export const MODULE_VERSION_REQUIRED_INPUTS_TABLE_CELLS: Record<
  MODULE_VERSION_REQUIRED_INPUTS_COLUMN_ID,
  (props: TableSimpleCellProps<ModuleVersionRequiredInputRow>) => JSX.Element
> = {
  [MODULE_VERSION_REQUIRED_INPUTS_COLUMN_ID.NAME]: ModuleVersionTableNameCell,
  [MODULE_VERSION_REQUIRED_INPUTS_COLUMN_ID.TYPE]: ModuleVersionInputsTableTypeCell,
  [MODULE_VERSION_REQUIRED_INPUTS_COLUMN_ID.DESCRIPTION]: ModuleVersionInputsTableDescriptionCell,
  [MODULE_VERSION_REQUIRED_INPUTS_COLUMN_ID.SETTINGS]: ModuleVersionTableEmptyCell,
};

export const MODULE_VERSION_OPTIONAL_INPUTS_TABLE_CELLS: Record<
  MODULE_VERSION_OPTIONAL_INPUTS_COLUMN_ID,
  (props: TableSimpleCellProps<ModuleVersionOptionalInputRow>) => JSX.Element
> = {
  [MODULE_VERSION_OPTIONAL_INPUTS_COLUMN_ID.NAME]: ModuleVersionTableNameCell,
  [MODULE_VERSION_OPTIONAL_INPUTS_COLUMN_ID.TYPE]: ModuleVersionInputsTableTypeCell,
  [MODULE_VERSION_OPTIONAL_INPUTS_COLUMN_ID.DEFAULT]: ModuleVersionInputsTableDefaultCell,
  [MODULE_VERSION_OPTIONAL_INPUTS_COLUMN_ID.DESCRIPTION]: ModuleVersionInputsTableDescriptionCell,
  [MODULE_VERSION_OPTIONAL_INPUTS_COLUMN_ID.SETTINGS]: ModuleVersionTableEmptyCell,
};
